import { getMomentTz, MESApiService } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { qualityStatus } from "../utils/qualityCheckMeasurements";
import { type SawRecentBundle, toRecentBundle } from "./sawWriteRepository";

const moment = getMomentTz();

export interface SawShiftBundle extends SawRecentBundle {
	ShiftSeq: number;
	QualityCheckId: number | null;
	CheckTime: Date | null;
	CreatedBy: string | null;
	EmployeeNumber: string | null;
	WorkOrderNumber: string | null;
}

interface SawBundlesShift {
	ShiftId: number | null;
	ProductionDate: string | null;
	ShiftLabel: string | null;
	Crew: string | null;
	PreviousShiftId: number | null;
	NextShiftId: number | null;
}

export interface SawBundlesByShift {
	shift: SawBundlesShift;
	rows: SawShiftBundle[];
	pendingCount: number;
}

export const getSawBundlesByShift = async (
	assetId: number,
	shiftId?: number | null,
): Promise<SawBundlesByShift> => {
	const response = await new MESApiService().callV2(
		"[FAB].[GetSawBundlesByShift]",
		[
			{ name: "AssetId", value: assetId },
			{ name: "ShiftId", value: shiftId ?? null },
		],
	);
	if (!response.ok)
		throw new Error(response.message || "Unable to load quality checks.");
	const shift = get(response, "data.tables[0].rows[0]") as
		| SawBundlesShift
		| undefined;
	if (!shift) throw new Error("Unable to resolve the selected shift.");
	const rows = (
		get(response, "data.tables[1].rows", []) as Record<string, unknown>[]
	).map(
		(row): SawShiftBundle => ({
			...toRecentBundle(row),
			ShiftSeq: row.ShiftSeq as number,
			QualityCheckId: (row.QualityCheckId as number) ?? null,
			CheckTime: row.CheckTime
				? moment.utc(row.CheckTime as string).toDate()
				: null,
			CreatedBy: (row.CreatedBy as string) ?? null,
			EmployeeNumber: (row.EmployeeNumber as string) ?? null,
			WorkOrderNumber: (row.WorkOrderNumber as string) ?? null,
		}),
	);
	return {
		shift,
		rows,
		pendingCount: rows.filter((row) => qualityStatus(row).pending).length,
	};
};
